export const checkPassportExistence = async (passport) => {

    const token = localStorage.getItem('token'); // Get token from localStorage
    const apiUrl = process.env.REACT_APP_API_URL;

    const response = await fetch(`${apiUrl}/api/client/${passport}/clientname`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`, // Attach the token here
        },
    });

    if (!response.ok) {
        if (response.status === 404) {
            console.error('Client not found');
            return null; // Or handle as needed
        }
        throw new Error('Failed to check passport existence');
    }

    return await response.json();
};